import {
  AudioIcon,
  PhotoIcon,
  PollIcon,
  StreamIcon,
  TypographyIcon,
  VideoIcon,
} from '@fourthwall/icons'

import type { TypeButton } from '../../components/PostTypeButtons/types'

export const TYPE_BUTTONS: TypeButton[] = [
  {
    type: 'Text',
    label: 'Text',
    icon: TypographyIcon,
  },
  {
    type: 'Image',
    label: 'Images',
    icon: PhotoIcon,
  },
  {
    type: 'Video',
    label: 'Video',
    icon: VideoIcon,
  },
  {
    type: 'Audio',
    label: 'Audio',
    icon: AudioIcon,
  },
  {
    type: 'Poll',
    label: 'Poll',
    icon: PollIcon,
  },
  {
    type: 'LiveStream',
    label: 'Livestream',
    icon: StreamIcon,
  },
]
